import * as React from "react";
import { Box, Card, Spinner, SpinnerProps } from "@origin-digital/ods-core";

export const Loading = ({ size }: { size?: SpinnerProps["size"] }) => (
  <Card>
    <Box width="full" justifyContent="center" display="flex">
      <Spinner size={size || "medium"} data-id="spinner" />
    </Box>
  </Card>
);
